import type { ProductLineItem } from '@weft/services';
import { isLineItemWithUnits, isCommitmentLineItem } from '@weft/services';
import { isNullOrUndefined } from '@weft/utils';
import { useMemo } from 'react';

export function useOverchargedChecker(productLineItem: ProductLineItem) {
  const isNotFixedLineItem = isLineItemWithUnits(productLineItem);
  const hasCommitment = isCommitmentLineItem(productLineItem);
  
  return useMemo(() => {
    if (!isNotFixedLineItem || !hasCommitment || isNullOrUndefined(productLineItem.lineItemProduct.commitment)) {
      return false;
    }
  
    return productLineItem.lineItemProduct.commitment.amount < productLineItem.lineItemProduct.commitment.consumption;
  }, [hasCommitment, isNotFixedLineItem, productLineItem]);
}